import { _post } from "../../Api";

export async function getReportingData(
  merchantId,
  selectedTaMerchantIds = [],
  selectedSpMerchantIds = [],
  range,
  translationTextSuccess,
  translationTextFailed
) {
  let data = {};
  data.ta_merchant_ids = [...selectedTaMerchantIds];
  data.sp_merchant_ids = [...selectedSpMerchantIds];
  data.from_date =
    range.startDate.getFullYear() + "-" + (range.startDate.getMonth() + 1) + "-" + range.startDate.getDate();
  data.to_date = range.endDate.getFullYear() + "-" + (range.endDate.getMonth() + 1) + "-" + range.endDate.getDate();
  // data = JSON.stringify(data);
  let result = { ta_receipts: [], sp_receipts: [] };
  for (let i = 0; i < selectedTaMerchantIds.length; i += 5) {
    await getReportingDataChunk(
      merchantId,
      selectedTaMerchantIds.slice(i, i + 5),
      [],
      range,
      translationTextSuccess,
      translationTextFailed
    ).then((res) => {
      result.ta_receipts = result.ta_receipts.concat(res.ta_receipts);
      result.sp_receipts = result.sp_receipts.concat(res.sp_receipts);
    });
  }
  for (let i = 0; i < selectedSpMerchantIds.length; i += 5) {
    await getReportingDataChunk(
      merchantId,
      [],
      selectedSpMerchantIds.slice(i, i + 5),
      range,
      translationTextSuccess,
      translationTextFailed
    ).then((res) => {
      result.ta_receipts = result.ta_receipts.concat(res.ta_receipts);
      result.sp_receipts = result.sp_receipts.concat(res.sp_receipts);
    });
  }
  return result;
}

async function getReportingDataChunk(
  merchantId,
  selectedTaMerchantIds = [],
  selectedSpMerchantIds = [],
  range,
  translationTextSuccess,
  translationTextFailed
) {
  let data = {};
  data.ta_merchant_ids = [...selectedTaMerchantIds];
  data.sp_merchant_ids = [...selectedSpMerchantIds];
  data.from_date =
    range.startDate.getFullYear() + "-" + (range.startDate.getMonth() + 1) + "-" + range.startDate.getDate();
  data.to_date = range.endDate.getFullYear() + "-" + (range.endDate.getMonth() + 1) + "-" + range.endDate.getDate();
  // data = JSON.stringify(data);

  return _post("/nova/v2/reporting", data)
    .then((res) => {
      return Promise.resolve(res.data);
    })
    .catch((e) => {
      console.log(e);
      return Promise.reject();
    });
}
